import { useContext } from 'react';
import { GuestSessionContext } from '../GuestSessionProvider';
import type { GuestSessionContextValue } from '../types';

const useGuestSession = (): GuestSessionContextValue => {
  const context = useContext(GuestSessionContext);

  if (!context) {
    throw new Error('useGuestSession must be used within a GuestSessionProvider');
  }

  return context;
};

export default useGuestSession;
